const StripeHelpers = {
    MIN_SEATS_COUNT: 3,
    monthlyPrice: () => 39,
    annualPrice: () => 12 * 32,
}

export default StripeHelpers
